import React, { useState, useEffect } from 'react';
import API from '../services/api';
import './AddServer.css'; // وارد کردن فایل CSS

const AddServer = () => {
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [port, setPort] = useState(4840); // مقدار پیش‌فرض پورت
    const [description, setDescription] = useState('');
    const [message, setMessage] = useState('');
    const [servers, setServers] = useState([]); // ذخیره لیست سرورها
    const [testResult, setTestResult] = useState('');

    const fetchServers = async () => {
        try {
            const response = await API.get('/servers/');
            setServers(response.data);
        } catch (error) {
            console.error('Failed to fetch servers:', error);
        }
    };

    useEffect(() => {
        fetchServers();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await API.post('/servers/', {
                name,
                address,
                port, // ارسال پورت به سرور
                description,
            });
            setMessage('Server added successfully!');
            setName('');
            setAddress('');
            setPort(4840); // بازنشانی به مقدار پیش‌فرض
            setDescription('');
            fetchServers(); // به‌روزرسانی لیست سرورها پس از افزودن
        } catch (error) {
            setMessage('Failed to add server.');
            console.error(error);
        }
    };

    const handleTestConnection = async () => {
        setTestResult('Testing connection...');
        if (!address || !port) {
            setTestResult('Please provide both address and port.');
            return;
        }

        try {
            const response = await API.post('/test-connection/', {
                address,
                port,
            });
            setTestResult(`Success: ${response.data.message}`);
        } catch (error) {
            setTestResult(`Failure: ${error.response?.data?.message || 'Unable to connect'}`);
        }
    };

    return (
        <div className="container">
            <h1 className="title">Add OPC Server</h1>
            <form className="form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label className="label">Server Name:</label>
                    <input
                        className="input"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="label">Server Address:</label>
                    <input
                        className="input"
                        type="text"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="label">Server Port:</label>
                    <input
                        className="input"
                        type="number"
                        value={port}
                        onChange={(e) => setPort(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="label">Description:</label>
                    <textarea
                        className="textarea"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    ></textarea>
                </div>
                <button className="button" type="submit">Add Server</button>
            </form>
            {message && <p className="message">{message}</p>}
            <button className="button" onClick={handleTestConnection}>Test Connection</button>
            {testResult && <p className="test-result">{testResult}</p>}

            <h2 className="title">Existing Servers</h2>
            <div className="server-list">
                <ul>
                    {servers.map((server) => (
                        <li className="server-item" key={server.id}>
                            <strong>{server.name}</strong>: {server.address}:{server.port} - {server.description}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default AddServer;
